import { render } from "./form-part-a-declaration.html?vue&type=template&id=578b66fc&scoped=true&ts=true&external"
import script from "./form-part-a-declaration.ts?vue&type=script&lang=ts&external"
export * from "./form-part-a-declaration.ts?vue&type=script&lang=ts&external"

import "./form-part-a-declaration.scss?vue&type=style&index=0&id=578b66fc&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-578b66fc"]])

export default __exports__